const mediaData = [
  {
    title: '暗夜追光 — 终极预告片',
    desc: '尘封二十年的真相即将揭开，层层反转挑战你的推理极限。年度悬疑巨制，每一秒都扣人心弦。',
    duration: '2:38',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20suspense%20thriller%20trailer%20style%20scene%20with%20dramatic%20spotlight%20on%20empty%20stage%2C%20deep%20crimson%20curtains%20and%20dark%20shadows%2C%20film%20noir%20aesthetic%20with%20mysterious%20atmosphere%2C%20professional%20movie%20trailer%20visual%20with%20play%20button%20overlay%20design%2C%20elegant%20dark%20composition%20with%20warm%20accent%20highlights&width=700&height=400&seq=media-preview-01&orientation=landscape',
  },
  {
    title: '狂飙2026 — 先导片花',
    desc: '张译张颂文再度联手，扫黑除恶风暴全面升级。三分钟先导片花抢先看，正邪较量一触即发。',
    duration: '3:15',
    img: 'https://readdy.ai/api/search-image?query=Dramatic%20police%20procedural%20trailer%20scene%20with%20urban%20cityscape%20at%20dusk%2C%20police%20car%20emergency%20lights%20reflecting%20on%20buildings%2C%20intense%20crime%20drama%20visual%20style%2C%20cinematic%20wide%20shot%20with%20dramatic%20lighting%2C%20professional%20film%20production%20quality%2C%20gritty%20yet%20stylish%20aesthetic%20with%20cool%20steel%20tones&width=700&height=400&seq=media-preview-02&orientation=landscape',
  },
  {
    title: '与凤行 — 绝美特效集锦',
    desc: '仙侠美学新标杆，每一帧都是壁纸级别的视觉享受。短短几分钟带你领略三界奇幻世界的震撼之美。',
    duration: '4:02',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20visual%20effects%20showcase%20with%20magical%20golden%20light%20particles%20swirling%20in%20air%2C%20ethereal%20Chinese%20xianxia%20landscape%20with%20floating%20islands%20and%20waterfalls%2C%20dreamy%20peach%20blossom%20petals%20dancing%20in%20wind%2C%20cinematic%20fantasy%20composition%20with%20vibrant%20yet%20elegant%20colors%2C%20high%20quality%20visual%20effects%20style&width=700&height=400&seq=media-preview-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-play-circle-line"></i>
            预告抢先看
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩预告</h2>
          <p className="mt-2 text-foreground-500 text-sm">热门剧集预告片与精彩花絮，提前感受追剧快乐</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item) => (
            <div
              key={item.title}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const el = e.currentTarget;
                    el.parentElement!.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                    <i className="ri-play-fill text-primary-600 group-hover:text-white text-2xl ml-0.5 transition-colors"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-black/60 backdrop-blur-sm text-white text-xs font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}